import eventBus from "../eventBus";
import uptFile from "./uptFile";
const _ = require("lodash");

class Selection {
  constructor() {
    this.selectionList = [];
    this.selectionMap = [];
  }

  initialize() {
    this.selectionList = [];
    this.createNewSelectionMap();
  }

  createNewSelectionMap() {
    const numberOfPicks = _.get(uptFile, "xmlData.patternPicksCount");
    const numberOfDrives = _.get(uptFile, "pickData.driveData.tagNames.length");
    if (numberOfPicks) {
      this.selectionMap = Array.from(
        { length: numberOfPicks },
        () => new Array(numberOfDrives)
      );

      _.forEach(this.selectionList, s => {
        this.selectionMap[s[0]][s[1]] = true;
      });
    } else {
      this.selectionMap = [];
    }
  }

  resetSelection(noEvent = false) {
    const oldSelection = this.selectionList;
    this.initialize();
    if (!noEvent && oldSelection.length !== 0) {
      eventBus.$emit("selectionUpdate", oldSelection);
    }
  }

  changeSelection(element) {
    if (this.selectionMap.length === 0) {
      this.initialize();
    }
    const isAlreadySelected =
      this.selectionMap[element[0]][element[1]] || false;

    if (isAlreadySelected) {
      const itemIndex = this.selectionList.findIndex(
        e => e[0] === element[0] && e[1] === element[1]
      );
      this.selectionList.splice(itemIndex, 1);
      this.selectionMap[element[0]][element[1]] = false;
    } else {
      this.selectionList.push(element);
      this.selectionMap[element[0]][element[1]] = true;
    }
    eventBus.$emit("selectionUpdate", [element]);
  }

  changeColumnSelection(columnIndex) {
    if (this.selectionMap.length === 0) {
      this.initialize();
    }

    let updatedSelection;
    if (this.selectionMap.map(s => s[columnIndex]).includes(true)) {
      updatedSelection = _.remove(
        this.selectionList,
        s => s[1] === columnIndex
      );
    } else {
      updatedSelection = new Array(uptFile.xmlData.patternPicksCount)
        .fill(0)
        .map((_a, i) => [i, columnIndex]);
      this.selectionList.push(...updatedSelection);
    }
    this.createNewSelectionMap();
    eventBus.$emit("selectionUpdate", updatedSelection);
  }

  changePickSelection(pickIndex) {
    if (this.selectionMap.length === 0) {
      this.initialize();
    }

    let updatedSelection;
    if (this.selectionMap[pickIndex].includes(true)) {
      updatedSelection = _.remove(this.selectionList, s => s[0] === pickIndex);
    } else {
      updatedSelection = new Array(uptFile.pickData.driveData.tagNames.length)
        .fill(0)
        .map((_a, i) => [pickIndex, i]);
      this.selectionList.push(...updatedSelection);
    }
    this.createNewSelectionMap();
    eventBus.$emit("selectionUpdate", updatedSelection);
  }

  isSelectionContinuous() {
    if (this.selectionList.length <= 1) {
      return false;
    }
    let valid = true;
    const elements = [];
    const headerColumn = _.head(this.selectionList)[1];
    this.selectionList.map(s => {
      if (s[1] !== headerColumn) {
        valid = false;
      }
      elements.push(s[0]);
    });
    if (!valid) {
      return false;
    }
    const sortedElements = _.sortBy(elements);
    let value = sortedElements[0];

    for (let i = 0; i < sortedElements.length; i++) {
      if (sortedElements[i] !== value) {
        return false;
      }
      value = sortedElements[i] + 1;
    }
    return true;
  }

  isSelectionPicksOnly() {
    const occurences = _.countBy(this.selectionList, s => s[0]);
    const nrOfDrives = uptFile.pickData.driveData.tagNames.length;
    const occurencesList = Object.values(occurences);
    for (var v of occurencesList) {
      if (!_.isEqual(v, nrOfDrives)) {
        return false;
      }
    }
    return true;
  }

  isSelectionDrivesOnly() {
    const occurences = _.countBy(this.selectionList, s => s[1]);
    const nrOfPicks = uptFile.xmlData.patternPicksCount;
    const occurencesList = Object.values(occurences);
    for (var v of occurencesList) {
      if (!_.isEqual(v, nrOfPicks)) {
        return false;
      }
    }
    return true;
  }

  isSelectionOneTypeOnly() {
    const typeIndexes = _.uniq(this.selectionList.map(s => s[1]));
    const typeNames = typeIndexes.map(
      t => uptFile.pickData.driveData.tagNames[t]
    );
    return _.uniq(typeNames).length === 1;
  }
}

const selection = new Selection();

export default selection;
